import { useSelector } from "react-redux";
import { tokenSelector } from '@podcasts/store/user';

export const useIsAuthenticated = () => {
    return  useSelector(tokenSelector);
}
